import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuthHeader } from 'react-auth-kit';
import useLogout from './useLogout';

const useDataFetching = (url, now = true) => {
  const authHeader = useAuthHeader();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null); // Store error object (message and status)
  const { handleLogout } = useLogout();

  const fetchData = useCallback(async () => {
    if (url) {
      try {
        setLoading(true);
        const response = await axios.get(url, {
          headers: {
            Authorization: authHeader(),
          },
        });

        // Set data if the request is successful
        setData(response.data);
        setError(null); // Clear any previous error
        setLoading(false);
      } catch (error) {
        console.error("🚀 ~ fetchData ~ error:", error);

        // Handle 401 Unauthorized or token expiration
        if (error.response?.status === 401 || error.response?.data?.message?.includes("JWT token has expired")) {
          handleLogout();
        }

        // Set error state
        setError({
          status: error.response?.status || 'Unknown',
          message: error.response?.data?.message || 'An unknown error occurred',
        });
        setData([]);
        setLoading(false);
      }
    }
  }, [url]);

  useEffect(() => {
    now && fetchData();
  }, [url]);

  return [loading, error, data, fetchData];
};

export default useDataFetching;